export const ESTILOS = [{
    body: {
        paddingTop: 35,
        paddingBottom: 50,
        paddingHorizontal: 25,
    },
    section: {
        position:"relative",
        width: "100%",
        height: "90vh",
        border: "1px solid #000"
    },
    row: {
        flexDirection: 'row'
    },

    logo: {
        height: 50,
        width:"auto",
        marginLeft: 0,
    },
    colContent40: {
        paddingHorizontal: 10,
        width: "20%"
    },
    colContent60: {
        paddingHorizontal: 10,
        width: "80%"
    },
    colContent100: {
        paddingHorizontal: 10,
        width: "100%"
    },

    Negrita: {
        fontSize: 12,
        fontWeight: "bold"
    },
    Italica: {
        fontStyle: "italic"
    },
    textPeq: {
        fontSize: 8,
        marginBottom: 5,
        textAlign: 'left',
    },

    header1Left: {
        fontSize: 10,
        marginBottom: 5,
        textAlign: 'left',
    },
    header1Right: {
        fontSize: 10,
        marginBottom: 5,
        textAlign: 'right',
    },

    custonMt10: {
        marginTop: 10,
    },
    custonMt20: {
        marginTop: 20,
    },
    custonMt30: {
        marginTop: 30,
    },

    titulo: {
        backgroundColor: "#CCC"
    },
    customMl: {
        paddingHorizontal: 10,
    },

    borde: {
        border: 0.8,
        borderRadius: 4,
        padding: 5,
    },

    font4: {
        fontSize: 4,
    },
    font5: {
        fontSize: 5,
    },
    font6: {
        fontSize: 6,
    },
    font7: {
        fontSize: 7,
    },
    font8: {
        fontSize: 8,
    },
    font9: {
        fontSize: 9,
    },
    font10: {
        fontSize: 10,
    },
    font12: {
        fontSize: 12,
    },
    font14: {
        fontSize: 14,
    },
    font16: {
        fontSize: 16,
    },
    center: {
        textAlign: 'center',
    },
    right: {
        textAlign: 'right',
    },

    borderTop: {
        borderTop: 0.5
    },
    bordeAll:{
        padding: 3,
        borderBottom: 0.5,
        borderLeft: 0.5,
        borderRight: 0.5,
        borderTop: 0.5
    },
    bordeRTB:{
        padding: 3,
        borderBottom: 0.5,
        borderRight: 0.5,
        borderTop: 0.5
    },
    bordeLRBSP:{
        borderBottom: 0.5,
        borderRight: 0.5,
        borderLeft: 0.5
    },
    bordeRSP:{
        borderRight: 0.5,
    },
    bordeLRB:{
        padding: 3,
        borderBottom: 0.5,
        borderRight: 0.5,
        borderLeft: 0.5
    },
    bordeLR:{
        padding: 3,
        borderRight: 0.5,
        borderLeft: 0.5
    },
    bordeLRT:{
        padding: 3,
        borderTop: 0.5,
        borderRight: 0.5,
        borderLeft: 0.5
    },
    bordeRT:{
        padding: 3,
        borderTop: 0.5,
        borderRight: 0.5,
    },
    bordeL:{
        padding: 3,
        borderLeft: 0.5
    },
    bordeR:{
        padding: 3,
        borderRight: 0.5,
    },
    bordeRB:{
        padding: 3,
        borderRight: 0.5,
        borderBottom: 0.5,
    },

    colTabla10: {
        width: 10,
        borderColor: "#000"
    },
    colTabla20: {
        width: 20,
        borderColor: "#000"
    },
    colTabla30: {
        width: 30,
        borderColor: "#000"
    },
    colTabla40: {
        width: 40,
        borderColor: "#000"
    },
    colTabla50: {
        width: 50,
        borderColor: "#000"
    },
    colTabla60: {
        width: 60,
        borderColor: "#000"
    },
    colTabla70: {
        width: 70,
        borderColor: "#000"
    },
    colTabla75: {
        width: 75,
        borderColor: "#000"
    },
    colTabla80: {
        width: 80,
        borderColor: "#000"
    },
    colTabla90: {
        width: 90,
        borderColor: "#000"
    },
    colTabla100: {
        width: 100,
        borderColor: "#000"
    },
    colTabla120: {
        width: 120,
        borderColor: "#000"
    },
    colTabla130: {
        width: 130,
        borderColor: "#000"
    },
    colTabla150: {
        width: 150,
        borderColor: "#000"
    },
    colTabla160: {
        width: 160,
        borderColor: "#000"
    },
    colTabla175: {
        width: 175,
        borderColor: "#000"
    },
    colTabla210: {
        width: 210,
        borderColor: "#000"
    },
    colTabla230: {
        width: 230,
        borderColor: "#000"
    },
    colTabla240: {
        width: 240,
        borderColor: "#000"
    },
    colTabla250: {
        width: 250,
        borderColor: "#000"
    },
    colTabla270: {
        width: 270,
        borderColor: "#000"
    },
    colTabla280: {
        width: 280,
        borderColor: "#000"
    },
    colTabla320: {
        width: 320,
        borderColor: "#000"
    },
    colTabla330: {
        width: 330,
        borderColor: "#000"
    },
    colTabla400: {
        width: 400,
        borderColor: "#000"
    },
    colTabla420: {
        width: 420,
        borderColor: "#000"
    },
    colTabla430: {
        width: 430,
        borderColor: "#000"
    },
    colTabla450: {
        width: 450,
        borderColor: "#000"
    },
    colTabla490: {
        width: 490,
        borderColor: "#000"
    },
    colTabla550: {
        width: 550,
        borderColor: "#000"
    },
}]


// WEBPACK FOOTER //
// ./src/components/Reportes/Styles/StylesBeca.jsx